export class SetPhoneController {
    /* @ngInject */
    constructor(passwordCredentialsService, $log, contactPointService, authenticatedUserService, $timeout, $state, $stateParams, destinationOrganization, userSession, account, toastr, $translate) {
        this.passwordCredentialsService = passwordCredentialsService;
        this.contactPointService = contactPointService;
        this.userSessions = userSession;
        this.account = account;
        this.toast = toastr;
        this.destinationOrganization = destinationOrganization;
        this.authenticatedUserService = authenticatedUserService;
        this.twoFactorEnabled = destinationOrganization.securityConfiguration.twoFactorEnabled;
        this.approvedContactPoints = destinationOrganization.securityConfiguration.approvedContactPointTypes;
        this.$log = $log;
        this.$timeout = $timeout;
        this.$state = $state;
        this.$stateParams = this.$stateParams;
        this.state = $stateParams.state;
        this.popup = $stateParams.popup ? $stateParams.popup : false;
        this.username = $stateParams.username;
        this.activateFormData = {
            value: null,
            code: null
        };
        this.user = {};
        this.activateResponse = null;
        this.phoneVerificationAction = 'VERIFY_PHONE';
        this.phoneType = 'PHONE';
        this.action = {
            request: 'REQUEST',
            send: 'SEND',
            show: false
        };
        this.errorResponse = null;
        this.verifyUserSession();
        this.skip = null;
        this.toast.options = {
            "showDuration": "6000"
        };
        this.$translate = $translate;
    }

    verifyUserSession() {
        if (this.userSessions.length == 1) {
            this.user = this.userSessions[0];
            if (this.user.activated === true && this.user.contactPoints) {
                var phone = this.phoneType;
                this.user.contactPoints.forEach(function (cp) {
                    if (cp.type === phone) {
                        phone = cp.address;
                    }
                });
                this.activateFormData.value = phone !== this.phoneType ? phone : "";
            }
        }
    }

    allowSkip() {
        if (this.state !== 'EDIT') {
            if(this.twoFactorEnabled !== true) {
                return true;
            }
            if(this.twoFactorEnabled === true) {
                if (this.approvedContactPoints.length === 1) {
                    if(this.approvedContactPoints[0] === "EMAIL") {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    getVerificationCode() {
        this.contactPointService.requestVerificationCodeForContactPoint(this.phoneVerificationAction, this.activateFormData.value)
            .then(response => {
                var i = this.phoneType.indexOf('_');
                this.$translate('authentication.send').then(translation => {
                    this.phoneType = this.phoneType.substring(this.phoneType.length, i != -1 ? i + 1 : 0);
                    this.toast.success(translation + this.phoneType.toLowerCase(), 'Success');
                    this.handleSuccess(response, this.action.request);
                });

            }, response => {
                this.$translate('authentication.send-not-send-error-phone').then( translation => {
                    this.toast.error(translation, 'Error');
                    this.handleError(response);
                });

            });
    }

    verifyPhone() {
        if (this.activateFormData.code) {
            this.contactPointService.verifyContactPoint(this.phoneVerificationAction, this.activateFormData.value, this.activateFormData.code)
                .then(() => {
                    let i = this.phoneType.indexOf('_');
                    this.phoneType = this.phoneType.substring(this.phoneType.length, i != -1 ? i + 1 : 0);
                    this.toast.success(this.phoneType.toLowerCase().charAt(0).toUpperCase() + this.phoneType.toLocaleLowerCase().slice(1) + ' er blevet aktiveret', 'Success');
                    if (this.state === 'ACTIVATE') {
                        this.handleActivation();
                    }
                }, response => {
                    this.$translate('authentication.send.error').then(translation => {
                        this.toast.error(translation, 'Error');
                        this.errorResponse = true;
                        this.handleError(response);
                    });
                });
        }
    }

    handleSubmit() {
        switch (this.state) {
            case 'EDIT': {
                this.verifyPhone();
                if (this.popup === "false" || this.popup === false) {
                    this.$state.go('flow');
                }
                break;
            }
            case 'ACTIVATE': {
                this.verifyPhone();
            }
        }
    }

    handleActivation() {
        if (this.user && this.username) {
            this.$state.go('setpassword', {
                id: this.user.id,
                username: this.username,
                email: this.$stateParams.email
            });
        }
    }

    handleSuccess(response, action = null) {
        if ((action) && action === this.action.request) {
            this.action.show = true;
        }
        this.activateResponse = response;
    }

    handleError(response) {
        this.activateResponse = response;
    }
}
